const STORAGE_KEY = 'ums-email-detail-header-collapsed-v1';

export function loadEmailDetailHeaderCollapsed(): boolean {
  try {
    return localStorage.getItem(STORAGE_KEY) === 'true';
  } catch {
    return false;
  }
}

export function saveEmailDetailHeaderCollapsed(collapsed: boolean): void {
  try {
    localStorage.setItem(STORAGE_KEY, collapsed ? 'true' : 'false');
  } catch {
    /**/
  }
}
